import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function AC() {
	return (
		<div>
			<NeonHero
				title="A/C & Climate"
				subtitle="Leak tests, recharge, compressors and condensers with performance validation."
				primaryCta={{ label: 'Book A/C Service', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">We handle</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>R134a and R1234yf systems</li>
					<li>Evaporators, condensers, compressors</li>
					<li>Thermal management and cabin filters</li>
					<li>Performance and leak verification</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Visual and UV inspections</li>
							<li>Vacuum, recharge and performance test</li>
							<li>Component replacement if required</li>
							<li>Final validation</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">0% for 12 months with approved credit via Affirm/Klarna.</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Most services: same-day. Component replacements: 1–2 days.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
